export const EXTENSION_TYPES = {
    1:{
        name: '科学'
    },
    2:{
        name: '艺术'
    },
    3:{
        name: '人文'
    }

}

export const READING_FOOTER_TYPE ={
    LEVEL : 1,
    BACKGROUND_VIDEO: 2,
    NEW_WORD : 3
}

export const ANSWER_FOOTER_TYPE ={
    LEVEL : 1,
    ARTICLE_REVIEW: 2,
    QUIZ_LIST : 3
}

export const ANSWER_RESULT_FOOTER_TYPE ={
    LEVEL : 1,
    WRONG_ANSWER: 2,
    NEW_WORD : 3
}




//////////////////
// WEBPACK FOOTER
// ./app/contants/article.js
// module id = null
// module chunks = 